import createBrowserHistory from 'history/createHashHistory'
//import history from './history';

//const hashHistory = history.createHashHistory();
const customHistory = createBrowserHistory();

export default customHistory;